import React, { useEffect } from 'react';
import './ReviewRollover.scss';
import { RolloverConstants } from '../../RolloverConstants';
import { useSelector } from 'react-redux';
import TRP from '../../../Shared/TRP/TRP';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';

function ReviewRollover() {
  useEffect(() => {
    dispatchPageLoad('Review Details');
  }, []);
  const fundingTrackingData = useSelector(
    (state) => state?.fundingTrackingData
  );
  const formValues = {
    rolloverToAccountType:
      fundingTrackingData?.store?.userAccountFundingData?.agreementType || '',
    rolloverToAccountNumber:
      fundingTrackingData?.store?.AccountAgreementNumber || '',
    externalFiName:
      fundingTrackingData?.payload?.onboardingDataStore
        ?.onboardingDatastoreRollover?.externalFinancialInstituteName || '',
    formalEmployerName:
      fundingTrackingData?.payload?.onboardingDataStore
        ?.onboardingDatastoreRollover?.formalEmployerName || '',
    rolloverType:
      fundingTrackingData?.payload?.onboardingDataStore
        ?.onboardingDatastoreRollover?.onboardingRolloverType || '',
  };

  const RollOverTo = () => {
    return (
      <div className="rollover-form">
        <div className="form-title">
          {RolloverConstants?.rolloverReviewPage?.labels?.RolloverTo}
        </div>
        <div className="line-thick" />

        <div className="table">
          <div className="row">
            <div className="item">Firm Name</div>
            <div className="content">
              <TRP />
            </div>
          </div>
          <div className="line-thin" />
          <div className="row">
            <div className="item">Account Type</div>
            <div className="content">
              {fundingTrackingData?.store?.normalizedAccountType}
            </div>
          </div>
          <div className="line-thin" />
          <div className="row">
            <div className="item">Account Number</div>
            <div className="content blocked_data">{`${formValues.rolloverToAccountNumber}`}</div>
          </div>
          <div className="line-thin" />
        </div>
      </div>
    );
  };

  const RollOverFrom = () => {
    return (
      <div className="rollover-form">
        <div className="form-title">Rollover From:</div>
        <div className="line-thick" />

        <div className="table">
          <div className="row">
            <div className="item">Firm Name</div>
            <div className="content">{formValues?.externalFiName}</div>
          </div>
          <div className="line-thin" />
          <div className="row">
            <div className="item">Employer Name</div>
            <div className="content">{formValues?.formalEmployerName}</div>
          </div>
          <div className="line-thin" />
        </div>
      </div>
    );
  };

  const RollOverType = () => {
    return (
      <div className="rollover-form">
        <div className="form-title">Rollover Type:</div>
        <div className="line-thick" />

        <div className="table">
          <div className="row">
            <div className="item">Rollover Type</div>
            <div className="content">
              {formValues?.rolloverType === 'DIRECT'
                ? 'Direct Rollover'
                : formValues?.rolloverType === 'INDIRECT'
                ? 'Indirect Rollover'
                : null}
            </div>
          </div>
          <div className="line-thin" />
        </div>
      </div>
    );
  };

  return (
    <div id="rollover-page" className="rollover-review-details">
      <div className="page-header">
        <div className="title">Review your rollover details</div>
      </div>
      <div className="page-body">
        <RollOverTo />
        <RollOverFrom />
        <RollOverType />
      </div>
    </div>
  );
}

export default ReviewRollover;
